import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useUpdateBuyOrder } from 'services/buy-process';
import { useBuyProcessForm } from '../../buy-process-form-utils';
import { RootState } from '../../../../global';
import { StockRestrictions } from '../../../../global/entities/BuyOrder';
import { RadioConvertUtils } from '../../../../utils/radio/radio';
import { saveEditReservation } from '../../../admin/buy-process/buy-order-edit/buy-order-edit-redux';
import {
  onGoBackInForm,
  onGoForwardInForm,
  useSaveBuyOrderFormState,
} from '../../use-buy-process-form';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import {
  ReservationFormState,
  ReservationStoreState,
} from './reservation-types';

const getStockRestrictions = (
  initialState?: ReservationStoreState,
): ReservationFormState['stockRestrictions'] => {
  if (!initialState) return String(StockRestrictions.RightFirstOffer) as any;
  return String(initialState.stockRestrictions) as any;
};

export const useReservation = () => {
  const { setRequestedStep, id } = useBuyProcessForm();

  const initialState = useSelector(
    (state: RootState) => state.buyOrderEdit[id].reservation,
  );

  const formMethods = useForm<ReservationFormState>({
    defaultValues: {
      stockRestrictions: getStockRestrictions(initialState),
      rightFirstRefusal: RadioConvertUtils.boolToStr(
        initialState?.rightFirstRefusal,
      ),
    },
  });

  useSaveBuyOrderFormState(
    saveEditReservation,
    formMethods.getValues(),
    formMethods.trigger,
  );

  const dispatch = useDispatch();
  const isAdmin = useIsAdminOnBuyOrderEditForm();
  const [updateBuyOrder, updateBuyOrderMeta] = useUpdateBuyOrder(id);

  return {
    formMethods,
    isUpdating: updateBuyOrderMeta.isLoading,
    onSubmit: formMethods.handleSubmit((data) => {
      dispatch(saveEditReservation({ ...data, id }));
      updateBuyOrder();

      if (!isAdmin) {
        setRequestedStep((s) => s + 1);
      }
    }),
    onForward: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoForwardInForm(setRequestedStep, e),
    onBack: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoBackInForm(setRequestedStep, formMethods.trigger, e),
  };
};
